import axios from 'axios';

const API_URL = process.env.REACT_APP_API_ENDPOINT + '/api';

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  async (config) => {
    // const token = (await getStorageItem('accessToken')) || '';
    // config.headers.common.Authorization = `Bearer ${token}`;
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

export default instance;
